import BaseService from '@core/class/BaseService';

interface IPagination {
  page?: number;
  status?: string;
  fieldSearch?: string;
  productName?: string;
  sort?: boolean;
  fromDt?: string;
  toDt?: string;
}
class InquiryServices extends BaseService {
  public getListQuote = () => {
    return this.get('api/v1/seller/quotations');
  };
  public getListQuoteDetail = (productId: number | string) => {
    return this.get(`api/v1/seller/quotations/detail/${productId}`);
  };
  public getQuoteComment = (productId: number) => {
    return this.get(`api/v1/seller/comments/get-by-quotation/${productId}`);
  };

  public removeQuote = (productId: number | string) => {
    return this.delete(`api/v1/seller/quotations/${productId}`);
  };

  public updateQuote = (productId: number | string, body: any) => {
    return this.put(`api/v1/seller/quotations/${productId}`, body);
  };

  public exportExcel = ({
    fieldSearch,
    productName,
    sort,
    fromDt,
    toDt,
    status
  }: IPagination) => {
    let url = `api/v1/seller/quotations/export-all`;
    url =
      (!!productName && !!fieldSearch) || !!sort || !!fromDt || !!toDt
        ? url + '?'
        : url;
    // console.log(!!productName && !!fieldSearch, productName, fieldSearch, 1000);
    url +=
      (!!productName && !!fieldSearch
        ? `&filter.${productName}=${fieldSearch}`
        : '') +
      (!!fromDt ? `&filter.from=${fromDt}` : '') +
      (!!toDt ? `&filter.to=${toDt}` : '') +
      (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC`) +
      (!!status ? `&filter.status=${status}` : '');
    let urlUse = url.replace('?&', '?');
    return this.get(
      urlUse,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportExcelById = (productId: any) => {
    let value = '';
    productId.forEach((item: any) => {
      value = value + 'ids[]=' + item.key + '&';
    });
    return this.get(
      `api/v1/seller/quotations/export/?${value.substring(
        0,
        value.length - 1
      )}`,
      {},
      {
        responseType: 'blob'
      }
    );
  };
  public postRejectSell = (productId: number) => {
    return this.put(`api/v1/seller/quotations/reject/${productId}`);
  };
  public postApproveSell = (productId: number) => {
    return this.put(`api/v1/seller/quotations/approve/${productId}`);
  };
  public getPaging = ({
    productName,
    page,
    status,
    fieldSearch,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let url = 'api/v1/seller/quotations' + `?page=${page}&limit=10`;
    url = status !== '' && !!status ? (url += `&filter.status=${status}`) : url;
    url =
      productName !== '' &&
      productName !== null &&
      fieldSearch !== '' &&
      !!fieldSearch
        ? (url += `&filter.${fieldSearch}=${productName}`)
        : url;
    url = sort
      ? (url += `&sortBy=updated_at:DESC`)
      : (url += '&sortBy=updated_at:ASC');
    url = fromDt ? (url += `&filter.from=${fromDt}`) : url;
    url = toDt ? (url += `&filter.to=${toDt}`) : url;
    return this.get(url);
  };

  public upLoad = (body: Record<string, any>) => {
    return this.post('api/v1/seller/comments/upload', body);
  };
  public putEditComment = (idComment: number, body: Record<string, any>) => {
    return this.put(`api/v1/seller/comments/${idComment}`, body);
  };
  public createComment = (body: Record<string, any>) => {
    return this.post(`api/v1/seller/comments`, body);
  };
}

export default new InquiryServices('/', true);
